import HttpFactory from '@/mixins/http.factory';
export default {
	name:'authenticate-devops',
	mixins:[HttpFactory],
	data () {
		return {
			data:null,
			isFormValidated:false,
			disableValidateBtn:true,
      auth: { hdToken: 'xxx' },
      zendeskOauthRedirectUrl: null,
      browserUrl:null
		}
	},
	created(){
		this.init();
	},
	methods:{
		init(){
      let _self = this;
      _self.browserUrl = document.location.ancestorOrigins[0];
      _self.loading=true;
			modalClient = ZAFClient.init();
			parentClient=null;
			modalClient.on('send_data_to_modal', (data) => {
				parentClient = modalClient.instance(data.parentClientGuid)
				_self.zendeskInfo=data;

				_self.auth.userId=_self.zendeskInfo.userInfo?_self.zendeskInfo.userInfo.id:null;
        _self.auth.hdLoginUrl=_self.zendeskInfo.credentials.hdLoginUrl;//as of auth issues for differnt brand fixes trying
        _self.auth.hdEmail=_self.zendeskInfo.user.email;

        if(_self.$route.params.devOpsUrl){
            _self.auth.devOpsUrl=decodeURIComponent(_self.$route.params.devOpsUrl);
            _self.auth.userId=_self.$route.params.userId;
        }
				_self.loading=false;
			});
		},
		//auth only
		checkForm: function (e,installBtnClick) {
            let _self=this;
            if(!installBtnClick){
                _self.disableValidateBtn=true;
                _self.isFormValidated=false;
            }

            _self.userMsg.list = [];
            _self.userMsg.type='danger';
            if (_self.auth.hdLoginUrl && _self.auth.hdToken
            && _self.auth.devOpsUrl && _self.auth.devOpsToken) {
                return true;
            }
            return;
            if (!_self.auth.hdLoginUrl) {
                _self.userMsg.list.push('Zendesk Url is required.');
            } else if(!_self.validUrl(_self.auth.hdLoginUrl)){
                _self.userMsg.list.push('Zendesk Url is invalid.');
            }
            if (!_self.auth.hdToken) {
                _self.userMsg.list.push('Zendesk Token is  required.');
            }
			if (!_self.auth.hdEmail) {
                _self.userMsg.list.push('Zendesk Email is  required.');
            } else if(!_self.validEmail(_self.auth.hdEmail)){
				_self.userMsg.list.push('Zendesk Email is  invalid.');
			}
            if (!_self.auth.devOpsUrl) {
                _self.userMsg.list.push('Azure DevOps Url is  required.');
            }else if(!_self.validUrl(_self.auth.devOpsUrl)){
                _self.userMsg.list.push('Azure DevOps Url is invalid.');
            }
            if (!_self.auth.devOpsToken) {
                _self.userMsg.list.push('Azure DevOps Token is required.');
            }
            if(e){
                e.preventDefault();
            }
        },
        authenticate(e,cb){
            let _self = this;
            _self.zendeskOauthRedirectUrl=null
            //if(!_self.checkForm(e)) return;
            _self.loading=true;
            _self.auth.appId=_self.zendeskInfo.credentials.appId;
            _self.auth.installationId=_self.zendeskInfo.credentials.installationId;
            _self.auth.user=_self.zendeskInfo.user;
            var options = {
                method: 'POST',
                body: _self.auth,
                json: true,
                //url: _self.baseUrl+'authenticate',
				        url:'authenticate/devops',
                headers: {'Content-Type': 'application/json'}
            };
            _self.userMsg.type='danger';
            _self.userMsg.list=[];
            _self.isFormValidated=false;
            _self.post(options.url,options.body).then(function(response) {
                _self.loading=false;
                if(cb) cb(null,response);
                if(response.data.Data && response.data.Success){
                    _self.userMsg.type='info';
                    _self.isFormValidated=true;
                    _self.userMsg.list.push('Azure DevOps authentication completed successfully!.');
                  _self.userMsg.list.push('Please make sure pop-ups are allowed in your browser. A popup window will open shortly to complete the Zendesk OAuth authentication.   If the popup is blocked, please click the button below to open the authentication window.');
                  console.log('response.data.authUrl', response.data.authUrl);
                  console.log('auth redirect data received', 'good to go for zendesk oauth');
                    _self.zendeskOauthRedirectUrl=response.data.authUrl;
                    //window.open(_self.zendeskOauthRedirectUrl, '_blank');
                  let isPopupOpened = _self.fn().openOAuthPopup(_self.zendeskOauthRedirectUrl);
                  console.log('isPopupOpened', isPopupOpened);
                    if(isPopupOpened!==true){
                        _self.userMsg.list.push('It seems like the popup was blocked by your browser. Please click the button below to open the authentication window.');
                    } else {
                        _self.sendDataToParent(response.data);
                    }
                    //_self.init();
                }else{
                    _self.userMsg.list.push('App validation failed.');
                    if(response && response.data && response.data.Errors && response.data.Errors.length>0){
                        for(var i=0;i<response.data.Errors.length;i++){
                            _self.userMsg.list.push(response.data.Errors[i].Message);
                        }
                    }
                }
            },function(error){
                _self.loading=false;
                _self.userMsg.list.push('App validation failed.');
                if(error && error.response && error.response.Errors && error.response.Errors.length>0){
                    for(var i=0;i<error.response.Errors.length;i++){
                        _self.userMsg.list.push(error.response.Errors[i].Message);
                    }
                }
                if(cb) cb(error);
            });
        },
		validateEmpty:function(txt) {
            if (!txt || txt.trim() === '') {
                return false;
            } else {
                return true;
            }
        },
        validUrl: function (value) {
            return /^(?:(?:(?:https?|ftp):)?\/\/)(?:\S+(?::\S*)?@)?(?:(?!(?:10|127)(?:\.\d{1,3}){3})(?!(?:169\.254|192\.168)(?:\.\d{1,3}){2})(?!172\.(?:1[6-9]|2\d|3[0-1])(?:\.\d{1,3}){2})(?:[1-9]\d?|1\d\d|2[01]\d|22[0-3])(?:\.(?:1?\d{1,2}|2[0-4]\d|25[0-5])){2}(?:\.(?:[1-9]\d?|1\d\d|2[0-4]\d|25[0-4]))|(?:(?:[a-z\u00a1-\uffff0-9]-*)*[a-z\u00a1-\uffff0-9]+)(?:\.(?:[a-z\u00a1-\uffff0-9]-*)*[a-z\u00a1-\uffff0-9]+)*(?:\.(?:[a-z\u00a1-\uffff]{2,})))(?::\d{2,5})?(?:[/?#]\S*)?$/i.test(value);
        },
        validEmail: function (email) {
            var re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
            return re.test(email);
        },
		//auth ends
		closeDialog(){
			modalClient.invoke('destroy');
		},
		sendDataToParent(data){
			parentClient.trigger('receive_data_from_modal', data)
      		modalClient.invoke('destroy');
		},
	}
}

